'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.countTags = undefined;

var _camelcase = require('camelcase');

var _camelcase2 = _interopRequireDefault(_camelcase);

var _actions = require('../utils/actions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var countTags = exports.countTags = function countTags(query) {
  return {
    args: { query: query },
    type: 'CALL_MINDSELF_API',
    types: (0, _actions.getFetchActionTypes)('countTags'),
    minselfAPICall: function minselfAPICall(client) {
      return client.get(_actions.apiPrefix + '/tag/count', {
        q: query,
        resType: 'json'
      });
    }
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/mindself-api-client/lib/actions/tag.js
// module id = 509
// module chunks = 1